module.exports = __webpack_public_path__ + "img/stu_avatar_11.20c9548d.jpg";